import { mapTags } from '@gandi/translate';
import { Spinner } from '@gandi/ui';
import { contactTypes } from './definitions';
import { jsx as _jsx } from "react/jsx-runtime";
export const getBaseContactFields = (translator, currentContactType, role, process, contracts) => {
  const {
    __
  } = translator;
  const fields = [{
    field: 'type',
    label: __('Type of contact'),
    type: 'enum',
    description: __('Specify the type of the contact.'),
    required: true,
    values: contactTypes
  }];
  if (currentContactType && currentContactType !== 'individual') {
    fields.push({
      field: 'orgname',
      label: __('Legal name of the organization'),
      type: 'string',
      description: __('This is the full legal name of your company, association, ' + 'or public body. It will be displayed on whois data.'),
      required: true
    });
  }
  fields.push({
    field: 'given',
    label: __('Given name'),
    type: 'string',
    description: '',
    required: true
  });
  fields.push({
    field: 'family',
    label: __('Family name'),
    type: 'string',
    description: '',
    required: true
  });
  fields.push({
    field: 'address',
    subFields: ['streetaddr', 'zip', 'city', 'country', 'state'],
    type: 'address'
  });
  fields.push({
    field: 'phone',
    label: __('Phone number'),
    type: 'phone',
    description: __('Specify your phone number. Use the international format, ex: +1.199999999 for a US phone.'),
    required: true
  });
  fields.push({
    field: 'mobile',
    label: __('Mobile number'),
    type: 'phone',
    description: __('Specify your mobile number. Use the international format, ex: +1.199999999 for a US phone.')
  });
  fields.push({
    field: 'fax',
    label: __('Fax number'),
    type: 'phone',
    description: __('Specify your fax number. Use the international format, ex: +1.199999999 for the US.')
  });
  fields.push({
    field: 'email',
    label: __('Email'),
    type: 'string',
    description: __('Specify a valid email adress.'),
    required: true
  });
  if (role === 'owner' && process === 'edition') {
    const DNC_CONTRACT = contracts?.find(contract => contract.identifier === 'g1');
    const description = DNC_CONTRACT ? mapTags(__('You appoint Gandi as "Designated Agent" to act on your behalf and as ' + 'such, you agree that Gandi approves the change of email address in ' + 'accordance with ' + '[[gandiDNCLink:Gandi Domain name registration Contract]].'), ({
      gandiDNCLink
    }) => ({
      gandiDNCLink: /*#__PURE__*/_jsx("a", {
        href: DNC_CONTRACT.href,
        target: "_blank",
        rel: "noopener",
        children: gandiDNCLink
      })
    })) : /*#__PURE__*/_jsx(Spinner, {
      centered: true,
      name: "dots"
    });
    fields.push({
      field: 'icann_contract_accept',
      label: __('I authorize the registrar, Gandi, to be the "Designated Agent" under ICANN rules.'),
      type: 'checkbox',
      description
    });
  }
  fields.push({
    field: 'mail_obfuscated',
    label: __('Email address privacy'),
    sublabel: __("Hide email address in Gandi's public WHOIS database and at the registry."),
    type: 'boolean',
    description: mapTags(__('We take care of forwarding email to your address. ' + '[[whoisPrivacyLink:Learn more]].\n' + 'If you deactivate the option, you agree to your real email ' + 'address be stored in the registry database.'), ({
      whoisPrivacyLink
    }) => ({
      whoisPrivacyLink: /*#__PURE__*/_jsx("a", {
        href: __('https://docs.gandi.net/en/domain_names/common_operations/whois_privacy.html'),
        target: "_blank",
        rel: "noopener noreferrer",
        children: whoisPrivacyLink
      })
    })),
    required: true,
    defaultValue: true
  });
  fields.push({
    field: 'data_obfuscated',
    label: __('Personal data privacy'),
    sublabel: __("Hide personnal data in Gandi's public WHOIS database."),
    type: 'boolean',
    description: mapTags(__('Some extensions protect data at the registry level. ' + '[[tldListLink:See which ones]].\n' + 'If you deactivate the option, you agree to make all your data ' + ' public. [[whoisPrivacyLink:Learn more]].'), ({
      tldListLink,
      whoisPrivacyLink
    }) => ({
      tldListLink: /*#__PURE__*/_jsx("a", {
        href: __('https://docs.gandi.net/en/domain_names/common_operations/whois_privacy.html'),
        target: "_blank",
        rel: "noopener noreferrer",
        children: tldListLink
      }),
      whoisPrivacyLink: /*#__PURE__*/_jsx("a", {
        href: __('https://docs.gandi.net/en/domain_names/common_operations/whois_privacy.html'),
        target: "_blank",
        rel: "noopener noreferrer",
        children: whoisPrivacyLink
      })
    })),
    required: true,
    defaultValue: true
  });
  return fields;
};
export const getBaseContactFieldsField = (translator, currentContactType) => getBaseContactFields(translator, currentContactType).reduce((acc, field) => {
  if (Array.isArray(field.subFields)) {
    acc.push(...field.subFields);
  }
  if (field.field) {
    acc.push(field.field);
  }
  return acc;
}, []);
export const getIsFieldDisabledFn = args => fieldName => {
  if (args.process === 'transfer') return false;
  if (args.role === 'owner') {
    if (!args.process || args.process === 'create' || args.process === 'edition' || args.process === 'change_owner' && args.newOwner === 'custom' || args.process === 'change_owner' && args.newOwner === 'me') {
      if (args.contactType === 'individual') {
        return ['type', 'given', 'family', args.process === 'edition' && args.isIcannContractAccepted !== true && 'email'].indexOf(fieldName) > -1;
      }
      if (args.vatNumber) {
        return ['type', 'orgname', 'vat_number', 'extra_parameters.vat_number', args.process === 'edition' && args.isIcannContractAccepted !== true && 'email'].indexOf(fieldName) > -1;
      }
      if (args.contactType === 'individual') {
        return ['type', 'given', 'family', args.process === 'edition' && args.isIcannContractAccepted !== true && 'email'].indexOf(fieldName) > -1;
      }
      return ['type', 'orgname', args.process === 'edition' && args.isIcannContractAccepted !== true && 'email'].indexOf(fieldName) > -1;
    }
    return false;
  }
  return false;
};
export const filterDisabledFields = args => values => Object.keys(values).filter(key => !getIsFieldDisabledFn(args)(key)).reduce((acc, key) => ({
  ...acc,
  [key]: values[key]
}), {});